import React, { cloneElement } from 'react'
import SlickSlider from 'react-slick'
import PropTypes from 'prop-types'

const Slider = props => {
  const settings = {
    arrows: false,
    className: 'event-slider',
    infinite: false,
    initialSlide: props.slides.indexOf(props.active),
    afterChange: index => props.afterChange(props.slides[index])
  }
  const totalSlides = props.slides.map(slide => (
    <div className='slide ' key={slide}>
      {cloneElement(props.children, { id: slide })}
    </div>
  ))
  return (
    <div className='slider-container'>
      <SlickSlider {...settings}>{totalSlides}</SlickSlider>
    </div>
  )
}

Slider.propTypes = {
  slides: PropTypes.array.isRequired,
  active: PropTypes.number,
  afterChange: PropTypes.func
}

Slider.defaultProps = {
  active: 1,
  setActiveEntity: () => {}
}

export default Slider



// WEBPACK FOOTER //
// ./src/ui/sliders/slider.js